import React, { useCallback, useState } from 'react';
import Button from '../Button/Button';
import ModalHeader from './ModalHeader';
import ModalBody from './ModalBody';
import ModalFooter from './ModalFooter';
import Modal from './Modal';
import { Input } from '../Form';

type SimpleAddModalProps = {
  onClose: () => void;
  title: string;
  onSave: (value: string) => void;
  placeholder?: string;
};

const SimpleAddModal: React.FC<SimpleAddModalProps> = ({
  title,
  placeholder,
  onClose,
  onSave,
}) => {
  const [value, setValue] = useState('');
  const onChange = useCallback((e) => setValue(e.target.value), [setValue]);
  return (
    <Modal>
      <ModalHeader title={title} />
      <ModalBody>
        <Input
          m={3}
          mt={5}
          width={300}
          placeholder={placeholder}
          autoFocus
          value={value}
          onChange={onChange}
          onKeyUp={async (e) => {
            if (e.key === 'Enter' || e.key === 'NumpadEnter') {
              e.preventDefault();
              if (value) {
                onSave(value);
              }
            }
          }}
          autoComplete="off"
        />
      </ModalBody>
      <ModalFooter>
        <Button onClick={value ? () => onSave(value) : undefined} icon="plus">
          Save
        </Button>
        <Button onClick={onClose} variant="outline" icon="slash-circle">
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SimpleAddModal;
